import { __awaiter } from 'tslib';
import { im_proto } from '../../proto/index.js';
import { SdkConsts } from '../consts.js';
import { Logger } from '../metrics/logger.js';
import { BaseApiManager } from '../plugin/BaseApiManager.js';

class ApiManager extends BaseApiManager {
    SendMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                send_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    content: params.content,
                    mentioned_users: params.mentionedUsers,
                    client_message_id: params.clientId,
                    ticket: params.ticket,
                    message_type: params.messageType,
                    ext: params.ext,
                    ref_msg_info: params.referenceInfo
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.SEND_MESSAGE, {
                inboxType: params.inboxType,
                maxRetryTimes: this.ctx.option.maxSendMsgRetryTimes
            });
        });
    }
    GetMessagesByUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                messages_per_user_body: {
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            try {
                return yield this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MESSAGES_BY_USER, {
                    inboxType: params.inboxType,
                    maxRetryTimes: 1
                });
            }
            catch (err) {
                Logger.ctxWarn(this.ctx, `pull user error:${err}, ignore`);
                return im_proto.Response.create({
                    body: im_proto.ResponseBody.create({
                        messages_per_user_body: im_proto.MessagesPerUserResponseBody.create({
                            next_cursor: params.cursor,
                            has_more: false,
                            messages: []
                        })
                    })
                });
            }
        });
    }
    GetMessagesByUserInitV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                messages_per_user_init_v2_body: {
                    cursor: params.cursor,
                    init_sub_type: params.initSubType,
                    conv_limit: params.convLimit,
                    msg_limit: params.msgLimit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MESSAGES_BY_USER_INIT_V2, {
                inboxType: params.inboxType,
                forceHttp: true,
                maxRetryTimes: 10
            });
        });
    }
    GetMessagesByInit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                message_by_init: {
                    version: params.version,
                    page: params.page,
                    conv_limit: params.convLimit,
                    msg_limit: params.msgLimit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MESSAGE_BY_INIT, {
                inboxType: params.inboxType,
                forceHttp: true,
                maxRetryTimes: 10
            });
        });
    }
    GetMessagesByConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                messages_in_conversation_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    anchor_index: params.anchorIndex,
                    limit: params.limit,
                    direction: params.direction
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MESSAGES_BY_CONVERSATION, {
                inboxType: params.inboxType,
                forceHttp: true
            });
        });
    }
    CreateConversationV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                create_conversation_v2_body: {
                    conversation_type: params.type,
                    participants: params.participants,
                    persistent: params.persistent,
                    idempotent_id: params.idempotentId,
                    name: params.name,
                    avatar_url: params.avatarUrl,
                    description: params.desc,
                    biz_ext: params.bizExt
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.CREATE_CONVERSATION_V2, { inboxType: params.inboxType });
        });
    }
    GetConversationInfoListV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_conversation_info_list_v2_body: {
                    conversation_info_list: params.conversations.map(c => ({
                        conversation_id: c.conversationId,
                        conversation_short_id: c.conversationShortId,
                        conversation_type: c.conversationType
                    }))
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_CONVERSATION_INFO_LIST_V2, {
                inboxType: params.inboxType
            });
        });
    }
    MarkConversationReadV3(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_conversation_read_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    read_message_index: params.readIndex,
                    conv_unread_count: params.unreadCount,
                    total_unread_count: params.totalUnreadCount
                }
            });
            return this.send(reqBody, im_proto.IMCMD.MARK_CONVERSATION_READ_V3, {
                inboxType: params.inboxType,
                maxRetryTimes: 1
            });
        });
    }
    RecallMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                recall_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    server_message_id: params.serverId
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.RECALL_MESSAGE, { inboxType: params.inboxType });
        });
    }
    GetTicket(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_ticket_body: {
                    ticket_type: SdkConsts.ticketType,
                    conversation_type: params.conversationType,
                    conversation_short_id: params.shortId,
                    to_id: params.toId,
                    ext: params.ext
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_TICKET, { inboxType: params.inboxType })).get_ticket_body;
        });
    }
    GetConversationParticipantsList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                conversation_participants_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.CONVERSATION_PARTICIPANTS_LIST, {
                inboxType: params.inboxType
            });
        });
    }
    GetConversationParticipantByUserId(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mget_conversation_participants_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    participants: params.participants
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.MGET_CONVERSATION_PARTICIPANTS, {
                inboxType: params.inboxType
            });
        });
    }
    ClientAck(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const reqBody = im_proto.RequestBody.create({
                    client_ack_body: {
                        start_time_stamp: params.startTimeStamp,
                        cmd: params.cmd,
                        network_type: params.NetworkType,
                        logid: params.logid,
                        client_time_stamp: params.clientTimeStamp,
                        server_message_id: params.serverId,
                        type: params.type
                    }
                });
                yield this.send(reqBody, im_proto.IMCMD.CLIENT_ACK, {
                    useBeacon: true,
                    inboxType: params.inboxType
                });
            }
            catch (err) {
                Logger.ctxWarn(this.ctx, `send ack error: ${err}, ignore`);
            }
        });
    }
    ClientBatchAck(params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = (_a = params === null || params === void 0 ? void 0 : params.map) === null || _a === void 0 ? void 0 : _a.call(params, item => ({
                    start_time_stamp: item.startTimeStamp,
                    cmd: item.cmd,
                    network_type: item.NetworkType,
                    logid: item.logid,
                    client_time_stamp: item.clientTimeStamp,
                    server_message_id: item.serverId,
                    type: item.type
                }));
                const reqBody = im_proto.RequestBody.create({
                    client_batch_ack_body: {
                        ack_list: data
                    }
                });
                yield this.send(reqBody, im_proto.IMCMD.CLIENT_BATCH_ACK, {
                    useBeacon: true,
                    inboxType: (_b = params === null || params === void 0 ? void 0 : params[0]) === null || _b === void 0 ? void 0 : _b.inboxType
                });
            }
            catch (err) {
                Logger.ctxWarn(this.ctx, `send batch ack error: ${err}, ignore`);
            }
        });
    }
}

export { ApiManager };
//# sourceMappingURL=ApiManager.js.map
